import dayjs from 'dayjs';
import { GenericEventType } from '../../constants';
const TECH_COLORS = ['#4F46E5', '#7C3AED', '#DC2626', '#D97706', '#059669', '#0284C7', '#DB2777'];
const VISIT_STATUSES = [
    { key: 'scheduled', color: '#4F46E5', groupStatus: 'open' },
    { key: 'completed', color: '#059669', groupStatus: 'closed' },
    { key: 'in_progress', color: '#D97706', groupStatus: 'open' },
    { key: 'cancelled', color: '#6B7280', groupStatus: 'closed' }
];
const VISIT_TITLES = [
    'Annual Fire Inspection',
    'Quarterly Sprinkler Test',
    'Fire Extinguisher Service',
    'Emergency Exit Inspection',
    'Alarm System Check',
    'Suppression System Test',
    'Monthly Walk-Through',
    'Backflow Preventer Test'
];
const TECH_NAMES = ['Alex Thompson', 'Jordan Lee', 'Sam Rivera', 'Casey Morgan', 'Taylor Davis'];
function randomFrom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function randomDateInRange(start, end) {
    const startMs = start.getTime();
    const endMs = end.getTime();
    return new Date(startMs + Math.random() * (endMs - startMs));
}
export function generateMockVisits(count, dateRange) {
    return Array.from({ length: count }, (_, i) => {
        const start = randomDateInRange(dateRange.start, dateRange.end);
        const durationHours = randomInt(1, 4);
        const end = new Date(start.getTime() + durationHours * 60 * 60 * 1000);
        const techIndex = randomInt(0, TECH_NAMES.length - 1);
        const status = randomFrom(VISIT_STATUSES);
        return {
            id: 1000 + i,
            key: `visit-${1000 + i}`,
            start: dayjs(start).format('YYYY-MM-DDTHH:mm:ssZ'),
            end: dayjs(end).format('YYYY-MM-DDTHH:mm:ssZ'),
            daySpan: 1,
            title: randomFrom(VISIT_TITLES),
            visitableType: Math.random() > 0.3 ? 'Inspection' : 'WorkOrder',
            timeZone: 'America/New_York',
            assignee: {
                key: `tech-${techIndex}`,
                info: {
                    color: TECH_COLORS[techIndex % TECH_COLORS.length],
                    name: TECH_NAMES[techIndex]
                }
            },
            status,
            isVisit: true
        };
    });
}
export function generateMockTimeOffs(count, dateRange) {
    return Array.from({ length: count }, (_, i) => {
        const start = randomDateInRange(dateRange.start, dateRange.end);
        const end = new Date(start.getTime() + randomInt(4, 8) * 60 * 60 * 1000);
        const techIndex = randomInt(0, TECH_NAMES.length - 1);
        return {
            id: 2000 + i,
            key: `timeoff-${2000 + i}`,
            start: dayjs(start).format('YYYY-MM-DDTHH:mm:ssZ'),
            end: dayjs(end).format('YYYY-MM-DDTHH:mm:ssZ'),
            title: 'Time Off',
            technician: {
                id: 100 + techIndex,
                name: TECH_NAMES[techIndex],
                color: TECH_COLORS[techIndex % TECH_COLORS.length]
            }
        };
    });
}
export function generateMockHolidays(dateRange) {
    const holidays = [
        { month: 0, day: 1, title: "New Year's Day" },
        { month: 4, day: 26, title: 'Memorial Day' },
        { month: 6, day: 4, title: 'Independence Day' },
        { month: 8, day: 1, title: 'Labor Day' },
        { month: 10, day: 11, title: 'Veterans Day' },
        { month: 10, day: 27, title: 'Thanksgiving Day' },
        { month: 11, day: 25, title: 'Christmas Day' }
    ];
    const rangeStart = dayjs(dateRange.start);
    const rangeEnd = dayjs(dateRange.end);
    return holidays
        .map((h, i) => {
        const date = dayjs().year(rangeStart.year()).month(h.month).date(h.day);
        return {
            id: 3000 + i,
            key: `holiday-${3000 + i}`,
            start: date.format('YYYY-MM-DD'),
            end: date.format('YYYY-MM-DD'),
            title: h.title,
            allDay: true
        };
    })
        .filter((h) => {
        const d = dayjs(h.start);
        return d.isAfter(rangeStart) && d.isBefore(rangeEnd);
    });
}
export function generateMockGenericEvents(count, dateRange) {
    const eventTypes = [GenericEventType.On_call, GenericEventType.Training, GenericEventType.Site_visit];
    return Array.from({ length: count }, (_, i) => {
        const start = randomDateInRange(dateRange.start, dateRange.end);
        const allDay = Math.random() > 0.7;
        const end = allDay ? new Date(start) : new Date(start.getTime() + randomInt(1, 3) * 60 * 60 * 1000);
        const techIndex = randomInt(0, TECH_NAMES.length - 1);
        return {
            id: 4000 + i,
            key: `generic-${4000 + i}`,
            start: allDay ? dayjs(start).format('YYYY-MM-DD') : dayjs(start).format('YYYY-MM-DDTHH:mm:ssZ'),
            end: allDay ? dayjs(end).format('YYYY-MM-DD') : dayjs(end).format('YYYY-MM-DDTHH:mm:ssZ'),
            title: randomFrom(['On-Call Coverage', 'Safety Training', 'Site Assessment']),
            eventType: randomFrom(eventTypes),
            allDay,
            assignee: {
                key: `tech-${techIndex}`,
                info: {
                    color: TECH_COLORS[techIndex % TECH_COLORS.length],
                    name: TECH_NAMES[techIndex]
                }
            }
        };
    });
}
export function getMonthRange(year, month) {
    const start = new Date(year, month, 1);
    const end = new Date(year, month + 1, 0, 23, 59, 59);
    return { start, end };
}
export function visitsToProcessedEvents(visits) {
    return visits.map((v) => ({
        id: v.id,
        key: v.key,
        start: dayjs(v.start),
        end: dayjs(v.end),
        title: v.title,
        isVisit: true,
        assignee: v.assignee,
        status: v.status,
        timeZone: v.timeZone,
        visitableType: v.visitableType,
        daySpan: v.daySpan
    }));
}
export function timeOffsToProcessedEvents(timeOffs) {
    return timeOffs.map((t) => ({
        id: t.id,
        key: t.key,
        start: dayjs(t.start),
        end: dayjs(t.end),
        title: t.title,
        technician: t.technician
    }));
}
export function holidaysToProcessedEvents(holidays) {
    return holidays.map((h) => ({
        id: h.id,
        key: h.key,
        start: dayjs(h.start),
        end: dayjs(h.end),
        title: h.title,
        allDay: h.allDay
    }));
}
export function genericEventsToProcessedEvents(events) {
    return events.map((e) => ({
        id: e.id,
        key: e.key,
        start: dayjs(e.start),
        end: dayjs(e.end),
        title: e.title,
        allDay: e.allDay,
        assignee: e.assignee,
        eventType: e.eventType
    }));
}
